<template>
  <div>
    <div
      :class="{ 'has-error': validacao.$error }"
      class="form-group gridCheckbox"
    >
      <label v-if="exibeLabel" class="gridCheckboxLabel">
        <strong>{{ label }}</strong> <sup>{{ labelSup }}</sup>
      </label>

      <div class="gridCheckboxOptions">
        <div v-for="v in valores" :key="v[chave]" :title="v[descricao]">
          <label class="checkboxLabel">
            <input
              :data-test-id="`checkbox-${id}-${v[chave]}`"
              type="checkbox"
              :checked="descricaoEstaSelecionada(v[descricao])"
              :value="v[descricao]"
              @click="atualizar(v[descricao], valor)"
            />
            {{ v[descricao] }}
          </label>
          <div>
            <input
              v-if="descricaoEstaSelecionada(v[descricao])"
              v-model="complemento[v[descricao]]"
              :data-test-id="`input-${id}-complemento-${v[chave]}`"
              type="text"
              class="form-control input-sm"
              placeholder="Complemento..."
              @blur="$emit('complementar', complemento)"
            />
          </div>
        </div>
        <div v-if="mostrarOutros">
          <label class="checkboxLabel">
            <input
              :data-test-id="`checkbox-${id}-outro`"
              type="checkbox"
              :checked="exibirOutroInput"
              @click="aoClicarOutro"
            />
            <div>
              Outro
              <input
                v-if="exibirOutroInput"
                v-model="outroValor"
                :data-test-id="`input-${id}-outro`"
                type="text"
                class="form-control input-sm"
                @blur="atualizar(outroValor, valor)"
              />
            </div>
          </label>
        </div>
      </div>
      <div v-if="validacao.$dirty" class="help-block">
        <slot name="mensagensValidacao" />
      </div>
    </div>
  </div>
</template>

<script>
import { campoMixin } from '@/mixins/CampoMixin'
import { dominioMixin } from '@/mixins/DominioMixin'

export default {
  name: 'SelecionarDominio',
  mixins: [campoMixin, dominioMixin],
  props: {
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    mostrarTodos: {
      type: Boolean,
      default: true,
    },
    mostrarOutros: {
      type: Boolean,
      default: false,
    },
    dominio: {
      type: String,
      required: true,
    },
    chave: {
      type: String,
      default: '_id',
    },
    descricao: {
      type: String,
      default: 'valor',
    },
    complemento: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valores: [],
      multiplo: true,
      checkbox: true,
      exibirOutroInput: false,
      outroValor: '',
    }
  },
  async created() {
    const { valores } = await this.recuperarValoresDominio(this.dominio)
    this.valores = valores

    if (!this.valor) return

    const valoresSelecionados = this.valor.split(',')

    valoresSelecionados.forEach((v) => {
      const valoresItem = this.valores.find((item) => item.valor === v)
      if (!valoresItem) {
        this.outroValor = v
        this.exibirOutroInput = true
      }
    })
  },
  methods: {
    aoClicarOutro(event) {
      this.exibirOutroInput = event.target.checked

      if (!this.exibirOutroInput) {
        const valoresSelecionados = this.valorInterno.split(',')
        const novosValores = valoresSelecionados.filter(
          (v) => v !== this.outroValor
        )
        this.valorInterno = novosValores.join(',')
        this.$emit('atualizar', novosValores.join(','))
        this.outroValor = ''
      }
    },
    descricaoEstaSelecionada(descricao) {
      return this.valor.split(',').includes(descricao)
    },
  },
}
</script>

<style scoped>
.gridCheckboxOptions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
  row-gap: 8px;
  column-gap: 12px;
}

.checkboxLabel {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}
</style>
